<div class="container">
  <div class="text-right w-100">
    <button type="button" class="btn report-button" (click)="generateReport()">
      <i class="fas fa-file-excel-o"></i>Excel Report
    </button>
  </div>
  <form [formGroup]="filterForm">
    <div class="form-row">
      <div class="col-md-4 mb-3">
        <label for="startDate" [dir]="languageService.getDir()">From</label>
        <div class="input-group">
          <input type="text" id="startDate" name="startDate" class="form-control" placeholder="dd.mm.yyyy"
                 ngbDatepicker #sd="ngbDatepicker" firstDayOfWeek="0" [dir]="languageService.getDir()"
                 formControlName="startDate">
          <button class="btn btn-outline-secondary calendar" (click)="sd.toggle()" type="button">
            <i class="fas fa-calendar"></i>
          </button>
        </div>
      </div>
      <div class="col-md-4 mb-3">
        <label for="endDate" [dir]="languageService.getDir()">To</label>
        <div class="input-group">
          <input type="text" id="endDate" name="endDate" class="form-control" placeholder="dd.mm.yyyy"
                 ngbDatepicker #ed="ngbDatepicker" firstDayOfWeek="0" [dir]="languageService.getDir()"
                 formControlName="endDate">
          <button class="btn btn-outline-secondary calendar" (click)="ed.toggle()" type="button">
            <i class="fas fa-calendar"></i>
          </button>
        </div>
      </div>
      <div class="col-md-4 mb-3">
        <label for="orderStatus" [dir]="languageService.getDir()">Status</label>
        <select id="orderStatus" class="form-control" formControlName="orderStatus">
          <option value="ALL" selected>ALL</option>
          <option *ngFor="let status of orderStatusKeys" [value]="status">{{ orderStatuses[status] }}</option>
        </select>
      </div>
    </div>
  </form>
  <div class="user-list mt-3 mb-3 table-responsive" *ngIf="orders.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th scope="col" class="text-center">#</th>
        <th scope="col" class="text-center">Office</th>
        <th scope="col" class="text-center">Room</th>
        <th scope="col" class="text-center">Start Time</th>
        <th scope="col" class="text-center">End Time</th>
        <th scope="col" class="text-center">Type</th>
        <th scope="col" class="text-center">Status</th>
        <th scope="col" class="text-center">Coffee Cups</th>
        <th scope="col" class="text-center">Door Code</th>
        <th scope="col" class="text-center">User</th>
        <th scope="col" class="text-center" *ngIf="!isSuperAdmin"></th>
        <th scope="col" class="text-center" *ngIf="!isSuperAdmin"></th>
        <th scope="col" class="text-center"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let order of orders | paginate : {
                  itemsPerPage: pageSize,
                  currentPage: pageNumber,
                  totalItems: totalElements
                };
          let i = index">
        <td class="text-center">{{order.id}}</td>
        <td class="text-center">{{order.office.city + ', ' + order.office.address}}</td>
        <td class="text-center">{{order.room.name}}</td>
        <td class="text-center">{{order.start | date:'dd.MM.yy HH:mm' }}</td>
        <td class="text-center">{{order.end | date:'dd.MM.yy HH:mm' }}</td>
        <td class="text-center">{{order.bookingOption}}</td>
        <td class="text-center">{{order.status}}</td>
        <td class="text-center">{{order.coffeeCups}}</td>
        <td class="text-center">
          <div *ngIf="order.status != 'CANCELLED' && order.status != 'FINISHED'" class="mx-auto text-center">
            <ng-container *ngFor="let door of order.doors">
              <label *ngIf="door.name=='Main Entrance'">{{door.code}}</label>
            </ng-container>
            <ng-container>
              <a [routerLink]="['/qr/' + order.qrToken]" class="btn btn-sm qr-button">QR</a>
            </ng-container>
          </div>
        </td>
        <td class="text-center">
          {{order.user.email}}
        </td>
        <td class="text-center" *ngIf="!isSuperAdmin">
          <div *ngIf="order.status != 'CANCELLED' && order.status != 'STARTED' && order.status != 'FINISHED'" class="mx-auto text-center">
            <a (click)="orderCancel(order.id)" class="btn btn-sm btn-info">Cancel</a>
          </div>
        </td>
        <td class="text-center" *ngIf="!isSuperAdmin">
          <div *ngIf="order.status == 'PENDING'" class="mx-auto text-center">
            <a (click)="orderCheckout(order.id, order.duration, order.orderType)" class="btn btn-sm btn-info">Checkout</a>
          </div>
        </td>
        <td class="text-center">
          <div *ngIf="order.transaction.status == 'PAID'" class="mx-auto text-center">
            <a (click)="invoice(order.transaction.id)" class="btn btn-sm btn-info">Invoice</a>
          </div>
          <div *ngIf="order.transaction.status == 'PAID' && !isSuperAdmin" class="mx-auto text-center">
            <a (click)="sendToMonday(order)" class="btn btn-sm btn-info">To Monday</a>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="totalElements > 0" class="row justify-content-center">
    <div class="col-md-auto">
      <pagination-controls
        previousLabel="Prev"
        nextLabel="Next"
        responsive="true"
        (pageChange)="handlePageChange($event)"></pagination-controls>
    </div>
    <div class="col-md-auto">
      Items per page:
      <select (change)="handlePageSizeChange($event)">
        <option *ngFor="let size of pageSizes" [ngValue]="size">
          {{ size }}
        </option>
      </select>
    </div>
    <div class="col-md-auto">
      <div>{{ getMinLimit() }}-{{ getMaxLimit() }} of {{ totalElements }} items</div>
    </div>
  </div>
  <div *ngIf="orders.length == 0">
    <strong>You don't have orders yet.</strong>
  </div>
</div>
